<template>
	<ja-modal
		v-if="lifeStageData && steps && avatarImg"
		ref="modal"
		class="intro-modal"
		:class="{ ireland: this.$store.getters.isIrl }"
		:show="show"
	>
		<content>
			<div class="avatar-icon">
				<img :src="avatarImg" alt="" />
			</div>
			<div class="title-wrapper">
				<h1
					v-if="steps[currentStep].title"
					:aria-label="steps[currentStep].ariaTitle"
				>
					{{ steps[currentStep].title }}
				</h1>
				<h1 v-else-if="profileData.cmsLifeStage">
					{{ profileData.cmsLifeStage.name }}
				</h1>
				<h2 class="body-text-1">{{ steps[currentStep].subtitle }}</h2>
			</div>
			<component
				:is="steps[currentStep].component"
				class="component"
				@goNextStep="goNextStep"
				@goPrevStep="prevStep"
			>
				<ja-progress-tracker
					:num-pages="steps.length"
					:current-page="currentStep"
				></ja-progress-tracker>
			</component>
		</content>
	</ja-modal>
</template>
<script>
import '../icons/arrow-right';
import Modal from './Modal';
import Button from '../ui/Button';
import ProgressTracker from '../ui/ProgressTracker';
import LifeStageInfo from '../LifeStageIntro/LifeStageInfo';
import InitialBudgetCreator from '../LifeStageIntro/InitialBudgetCreator';
import NMICalculator from '../LifeStageIntro/NMICalculator';
import UserData from '@/mixins/UserData';
import LifeStageData from '@/mixins/LifeStageData';
import ProfileData from '@/mixins/ProfileData';
import ModalEvents from '@/mixins/ModalEvents';

export default {
	components: {
		jaModal: Modal,
		jaProgressTracker: ProgressTracker,
		jaButton: Button
	},
	mixins: [UserData, LifeStageData, ProfileData, ModalEvents],
	props: {
		show: {
			type: Boolean,
			default: false
		},
		currentStepPrev: {
			type: Number,
			default: null
		}
	},
	data() {
		return {
			buttonDisabled: false,
			currentStep: 0
		};
	},
	computed: {
		steps() {
			if (this.userData) {
				return [
					{
						subtitle: this.$t('lifeStageDesc'),
						component: LifeStageInfo,
						buttonDisabled: false
					},
					{
						title: this.$t('calculateNMITitle'),
						ariaTitle: this.$t('calculateNMIAriaTitle'),
						subtitle: this.$t('calculateNMIDesc'),
						component: NMICalculator,
						buttonDisabled: true
					},
					{
						title: this.$t('allocateSavingsTitle'),
						subtitle: this.$t('allocateSavingsDescription'),
						component: InitialBudgetCreator,
						buttonDisabled: true
					}
				];
			}
			return null;
		},
		isButtonDisabled() {
			return this.steps[this.currentStep].buttonDisabled;
		}
	},
	watch: {
		currentStepPrev: {
			handler(value) {
				if (value) {
					this.currentStep = this.currentStepPrev;
				}
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		goNextStep() {
			if (this.currentStep < this.steps.length - 1) {
				if (this.currentStep === 0) {
					this.$store.dispatch('showModalPassCode');
					this.$store.dispatch('hideModalAfterLifeStageIntro');
				}
				if (this.currentStep === 1) {
					this.$store.dispatch('showModalPassCode');
					this.$store.dispatch('hideModalCalculateNMI');
				}
				this.currentStep++;
				this.announceStep();
			} else {
				this.$emit('closeModal');
				this.$emit('showModalLifeStageIntro');
			}
		},
		prevStep() {
			this.isPrevStep = false;
			this.currentStep--;
			if (this.currentStep === 0) {
				this.$store.dispatch('hideModalAfterLifeStageIntro');
			}
			if (this.currentStep === 1) {
				this.$store.dispatch('hideModalCalculateNMI');
			}
			this.announceStep();
		},
		announceStep() {
			const step = this.steps[this.currentStep];
			const textToAnnounce = [];

			if (step.ariaTitle) {
				textToAnnounce.push(step.ariaTitle);
			} else {
				textToAnnounce.push(step.title);
			}

			textToAnnounce.push(step.subtitle);

			this.$announcer.polite(textToAnnounce.join(''));
		}
	}
};
</script>
<style>
.intro-modal {
	position: fixed;
	&.ireland {
		height: 100%;
		min-height: 100%;
		align-items: flex-start;
	}
}
.life-stage-intro {
	.modal-content-wrapper {
		height: 30vh;

		@media screen and (min-width: 1280px) and (max-width: 1440px) {
			height: 43vh;
		}

		@media screen and (min-width: 1440px) {
			height: 50vh;
		}
	}
}
</style>
